import type { Nullable, Nullish } from '@iheartjane/types';

import { STORE_ID_QUERY_KEY } from '@jane/bloom/utils/queryParams/queryParams';

interface Args {
  path: string;
  searchParams: URLSearchParams;
}

/**
 * Default store id can be set either as path param (/store/:storeId) or as query param (?storeid=<store_id>)
 */
export function getStoreIdFromUrl({
  path,
  searchParams,
}: Args): Nullable<number> {
  const pathMatch = path.match(/\/store\/(?<storeId>\d+)(?:\/|$)/);

  return (
    validatedStoreId(pathMatch?.groups?.['storeId']) ||
    validatedStoreId(searchParams.get(STORE_ID_QUERY_KEY))
  );
}

/**
 * Exported only for testing
 */
export const validatedStoreId = (value: Nullish<string>) => {
  const match = value?.match(/(?<digits>^\d+)/);
  if (match?.groups?.['digits']) {
    if (value !== match?.groups?.['digits']) {
      console.warn(`Stripping extra characters from store ID: ${value}`);
    }

    return Number(match.groups['digits']) || null;
  }
  return null;
};
